import { render, staticRenderFns } from "./MelhoresClientes.vue?vue&type=template&id=230a7d1d&scoped=true"
import script from "./MelhoresClientes.vue?vue&type=script&lang=js"
export * from "./MelhoresClientes.vue?vue&type=script&lang=js"
import style0 from "./MelhoresClientes.vue?vue&type=style&index=0&id=230a7d1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a7d1d",
  null
  
)

export default component.exports